<template>
  <a-card :bordered="false">
    <a-spin :spinning="spinning" tip="下载预计1到5分钟...">

      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="关键字">
                <a-input v-model="queryParam.keywords" allowClear placeholder="搜索关键字"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="赛季赛区">
                <!--                <a-cascader @change="onSjsqChange" :options="sjsqOptions"-->
                <!--                            :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区"-->
                <!--                            v-model="queryParam.sjsq" changeOnSelect-->
                <!--                />-->
                <a-cascader :show-search="{ sjsqFilter }" @change="onSjsqChange" :options="sjsqOptions" :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区" v-model="queryParam.sjsq" changeOnSelect />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="项目">
                <a-cascader :options="subjectOptions"
                            :fieldNames="{ label: 'name', value: 'key', children: 'children' }"
                            placeholder="请选择项目" v-model="queryParam.subjects" changeOnSelect
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="类型">  
                <a-select v-model="queryParam.type"  >
                  <a-select-option :value="1">决赛</a-select-option>
                  <a-select-option :value="2">预赛</a-select-option> 
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="评分状态">
                <r-switch :formData="queryParam" field="showScore" :checkedValue="1" :unCheckedValue="0"
                          checkedChildren="已评分" unCheckedChildren="未评分"/>
              </a-form-item>
            </a-col>

            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="授权编号">
                  <a-input v-model="queryParam.kaojiregist_code" placeholder="搜索授权编号"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="单位名称">
                  <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
                </a-form-item>
              </a-col>


              <a-col :md="6" :sm="24">
                <a-form-item label="考试时间">
                  <a-range-picker
                      v-model="time_range_moment"
                      style="width: 100%"
                      format="YYYY-MM-DD HH:mm:ss"
                      :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
                  />
                </a-form-item>
              </a-col>

            </template>
            <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons"
                  :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
                            <a-button style="margin-left: 8px" @click="createRankBook">生成项目排名表</a-button>
                            <a-button style="margin-left: 8px" @click="createPrize">计算项目奖项</a-button>
                            <a-button style="margin-left: 8px" @click="createAllRank()">批量生成排名表</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="table-operator">

        <a-button @click="download(1)" style="margin-left: 8px">
          成绩单下载
          <a-icon type="download"/>
        </a-button>

        <a-dropdown-button @click="download(3)">
          成绩册下载
          <a-menu slot="overlay"  >
            <a-menu-item key="1" @click="download(8)"> <a-icon type="download" />按赛区批量下载</a-menu-item> 
          </a-menu>
        </a-dropdown-button>
        <!--      <a-button @click="download(4)" style="margin-left: 8px"  >-->
        <!--        秩序册下载 <a-icon type="download" />-->
        <!--      </a-button>-->
        <a-dropdown>
          <a-button>秩序册操作</a-button>
          <a-menu slot="overlay">
            <a-menu-item>
              <a rel="noopener noreferrer" @click="download(4)"
              >秩序册更新</a
              >
            </a-menu-item>
            <a-menu-item>
              <a rel="noopener noreferrer" @click="download(5)"
              >秩序册下载</a
              >
            </a-menu-item>
            <a-menu-item>
              <a rel="noopener noreferrer" @click="download(6)"
              >秩序册PDF下载</a
              >
            </a-menu-item>
          </a-menu>
        </a-dropdown>

        <a-button @click="download(2)" style="margin-left: 8px">
          奖项信息下载
          <a-icon type="download"/>
        </a-button>
        <a-button  @click="downloadCertAll">项目批量下载成绩证书
          <a-icon type="download"/>
        </a-button>
        <a-button  @click="downloadSaiquCertAll">赛区批量下载成绩证书
          <a-icon type="download"/>
        </a-button>

      </div>
      <s-table
          ref="table"
          size="default"
          :columns="columns"
          :data="loadData"
          :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
          :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      >

      <span slot="danwei" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{ record.subject_name }}
            <br/><span style="color: #999">{{ record.mingcheng }}</span>
            <br/>
            {{ record.create_time|timeFormat }}
          </div>
      </span>
        <span slot="saiqu" slot-scope="text,record">
        {{ record.saiqu_name }}
      </span>
        <span slot="status" slot-scope="text,record">
        <div v-if="record.rank>0">
          分数: {{ record.score_total }}<br/>
          排名: {{ record.rank }} <a-tag color="red" v-if="record.prize">{{ record.prize }}</a-tag>
        </div>
        <div v-else>-</div>
      </span>
        <span slot="action" slot-scope="text,record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" v-if="record.rank>0"/>

          <a-dropdown v-if="record.rank>0">
            <a class="ant-dropdown-link">
              下载证书 <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item @click="downloadCert(record,0)">打印证书</a-menu-item>
              <!-- <a-menu-item @click="downloadCert(record,1)">带底图证书</a-menu-item> -->
            </a-menu>
          </a-dropdown>

        </template>
      </span>
      </s-table>


      <a-modal
        :maskClosable="false"
          title="操作"
          :width="1200"
          :footer="null"
          :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
          v-model="visible" 
      >
        <a-spin :spinning="saveLoading">
          <a-form :form="form">
            <a-row :gutter="48">
              <a-col :md="12" :sm="24">
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="赛区"
                    hasFeedback
                >
                  {{ formData.saiqu_name }}
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="项目名称"
                    hasFeedback
                >
                  {{ formData.subject_name }}
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="单位"
                  hasFeedback
              >
                {{ formData.danwei }}
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="队伍"
                  hasFeedback
              >
                {{ formData.mingcheng }}
              </a-form-item>
            </a-col>
            </a-row>
            <a-row :gutter="48">
              <a-col :md="12" :sm="24">
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="运动员"
                    hasFeedback
                >
                  <a-tag v-for="(user,index) in formData.yundongyuan" :key="index">{{ user.name }}</a-tag>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">

                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="替补运动员"
                    hasFeedback
                >
                  <a-tag v-for="(user,index) in formData.tbydy" :key="index">{{ user.name }}</a-tag>
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="48">
              <a-col :md="12" :sm="24">

                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="教练员"
                    hasFeedback
                >
                  <a-tag v-for="(user,index) in formData.jiaolian" :key="index">{{ user.name }}</a-tag>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">

              </a-col>
            </a-row>


            <a-divider>评分信息</a-divider>


            <a-row :gutter="48">
              <a-col :md="12" :sm="24">
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="分数1"
                    hasFeedback
                >
                  <!-- <a-input v-model='formData.score1' placeholder="请输入裁判1分数"/> -->

                  <editable-cell :text="formData['score1']" @change="onDataChange(formData, 1, $event)"/>

                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="分数2"
                    hasFeedback
                >
                  <!-- <a-input v-model='formData.score2' placeholder="请输入裁判2分数"/> -->

                  <editable-cell :text="formData['score2']" @change="onDataChange(formData, 2, $event)"/>

                </a-form-item>
              </a-col>
            </a-row>


            <a-row :gutter="48">
              <a-col :md="12" :sm="24">
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="分数3"
                    hasFeedback
                >
                  <!-- <a-input v-model='formData.score3' placeholder="请输入裁判3分数"/> -->

                  <editable-cell :text="formData['score3']" @change="onDataChange(formData, 3, $event)"/>

                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="分数4"
                    hasFeedback
                >
                  <!-- <a-input v-model='formData.score4' placeholder="请输入裁判4分数"/> -->
                  <editable-cell :text="formData['score4']" @change="onDataChange(formData, 4, $event)"/>

                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="48">
              <a-col :md="12" :sm="24">
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="分数5"
                    hasFeedback
                >
                  <!-- <a-input v-model='formData.score5' placeholder="请输入裁判5分数"/> -->
                  <editable-cell :text="formData['score5']" @change="onDataChange(formData, 5, $event)"/>

                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="分数6"
                    hasFeedback
                >
                  <!-- <a-input v-model='formData.score6' placeholder="请输入裁判6分数"/> -->
                  <editable-cell :text="formData['score6']" @change="onDataChange(formData, 6, $event)"/>

                </a-form-item>
              </a-col>
            </a-row>


            <a-row :gutter="48">
              <a-col :md="12" :sm="24">
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="分数7"
                    hasFeedback
                >
                  <!-- <a-input v-model='formData.score7' placeholder="请输入裁判7分数"/> -->
                  <editable-cell :text="formData['score7']" @change="onDataChange(formData, 7, $event)"/>

                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="分数8"
                    hasFeedback
                >
                  <!-- <a-input v-model='formData.score8' placeholder="请输入裁判8分数"/> -->
                  <editable-cell :text="formData['score8']" @change="onDataChange(formData, 8, $event)"/>

                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="48">
              <a-col :md="12" :sm="24">
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="分数9"
                    hasFeedback
                >
                  <!-- <a-input v-model='formData.score9' placeholder="请输入裁判9分数"/> -->
                  <editable-cell :text="formData['score9']" @change="onDataChange(formData, 9, $event)"/>

                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="分数10"
                    hasFeedback
                >
                  <!-- <a-input v-model='formData.score10' placeholder="请输入裁判10分数"/> -->
                  <editable-cell :text="formData['score10']" @change="onDataChange(formData, 10, $event)"/>

                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="48">
              <a-col :md="12" :sm="24">
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="加分"
                    hasFeedback
                >
                  <!-- <a-input v-model='formData.score_add' placeholder="裁判员加分"/> -->
                  <editable-cell :text="formData['score_add']" @change="onDataChange(formData, '_add', $event)"/>

                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="减分"
                    hasFeedback
                >
                  <!-- <a-input v-model='formData.score_pen' placeholder="裁判员减分"/> -->
                  <editable-cell :text="formData['score_pen']" @change="onDataChange(formData, '_pen', $event)"/>

                </a-form-item>
              </a-col>
            </a-row>


            <a-row :gutter="48">
              <a-col :md="12" :sm="24">
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="总分"
                    hasFeedback
                >
                  <!-- {{ formData.score_total = getTotalScore() }} -->
                  {{ formData.score_total }}
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="排名"
                    hasFeedback
                >
                  <!-- <a-input v-model="formData.rank" placeholder="请输入排名"/> -->

                  {{ formData.rank }}
                </a-form-item>
              </a-col>
            </a-row>


            <a-row :gutter="48">
              <a-col :md="12" :sm="24">
                <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="奖项"
                    hasFeedback
                >
                  <!-- <a-input v-model="formData.prize" placeholder="请输入奖项"/> -->
                  {{formData.prize}}

                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">

              </a-col>
            </a-row>

          </a-form>

        </a-spin>
        <!-- <template slot="footer"> -->
          <!-- <a-button key="cancel" @click="handleCancel">取消</a-button> -->
          <!-- <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button> -->
        <!-- </template> -->
      </a-modal>

      <a-modal
          :maskClosable="false"
          :footer="null"
          title="批量生成"
          v-model="createAllShow"
      >
        <p v-show="taskInfo.doing">正在批量生成成绩排名,请勿关闭或者刷新页面 <br/>
          <a-badge status="success" :text="'成功 '+(taskInfo.scount)"/>
          <a-divider type="vertical"/>
          <a-badge status="error" :text="'失败 '+(taskInfo.fcount)"/>
          <a-divider type="vertical"/>
          <a-badge status="processing" :text="'总数 '+(taskInfo.urls.length-1) "/>
        </p>
        <!--<p  v-show="!taskInfo.doing && scoreList2.exame.cert_zip">-->
        <!--<a @click="createAllCert(exame_id)">重新生成</a>-->
        <!--<a-divider type="vertical" />-->
        <!--<a @click="downloadCertSP()">批量下载</a>-->
        <!--</p>-->
        <!--<p  v-show="!taskInfo.doing && !scoreList2.exame.cert_zip">-->
        <!--<a @click="createAllCert(exame_id)">批量生成</a>-->
        <!--</p>-->
        <p>
          <a-progress :percent="taskInfo.percent"/>
        </p>
      </a-modal>

      <a-modal
          :maskClosable="false"
          :footer="null"
          title="批量下载"
          v-model="downloadAllShow"
      >
        <p v-show="taskInfo.doing">正在批量下载证书,请勿关闭或者刷新页面 <br/>
          <a-badge status="success" :text="'成功 '+(taskInfo.scount)"/>
          <a-divider type="vertical"/>
          <a-badge status="error" :text="'失败 '+(taskInfo.fcount)"/>
          <a-divider type="vertical"/>
          <a-badge status="processing" :text="'总数 '+(taskInfo.urls.length-1) "/>
        </p>
        <p v-show="!taskInfo.doing && downloadAllShow">
          <!--                <a @click="createAllCert()">重新生成</a>-->
          <!--                <a-divider type="vertical"/>-->
          <a @click="downloadScoreMp()">批量下载</a>
        </p>
        <!--              <p v-show="!taskInfo.doing && !certUrlDownload">-->
        <!--                <a @click="createAllCert()">批量下载</a>-->
        <!--              </p>-->
        <p>
          <a-progress v-show="taskInfo.doing" :percent="taskInfo.percent"/>
        </p>
      </a-modal>
    </a-spin>
  </a-card>
</template>

<script>
import STable from '@/components/table/'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
import EditableCell from '@/components/EditableCell/'
import PicUploader from '@/components/PicUploader/'
import FileUploader from '@/components/FileUploader/'
import RSwitch from '@/components/RSwitch/'
import setting from '@/config/setting'
import moment from 'moment'
import 'moment/locale/zh-cn';

moment.locale('zh-cn');

import {downloadAllCert, subjectOptions} from '@/api/sai'
import {doUrlTask} from '@/api/utils'
import qs from 'qs'
import {
  getSubjectScoreList,
  createRankBook,
  createPrize,
  subjectScoreDetail,
  subjectScoreEdit,
  getCreateRankUrls,
  zhixuceCreate,
  zhixuceDownload,
  setScore,
} from '@/api/dscore'
import {sjsqOptions} from '@/api/sai'

export default {
  name: 'KaojiApplySubjectList',
  components: {
    AInput,
    ATextarea,
    FileUploader,
    PicUploader,
    STable,
    EditableCell,
    RSwitch
  },
  data() {
    return {
      subjectOptions: [],
      sjsqOptions: [],
      spinning: false,
      visible: false,
      saveLoading: false,
      createAllShow: false,
      formData: {
        id: 0,
        jiaolian: [],
        caipan: [],
        yundongyuan: [],
        tbydy: [],
        subject_name: '',
        score1: 0,
        score2: 0,
        score3: 0,
        score4: 0,
        score5: 0,
        score6: 0,
        score7: 0,
        score8: 0,
        score9: 0,
        score10: 0,
        score_total: 0,
        scorepenadd: 0,
        score_add: 0,
        score_pen: 0,
      },
      time_range_moment: [],
      time_range: [],
      labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
        xs: {span: 24},
        sm: {span: 8},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 12},
      },
      form: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: '',
        type:2,
        showScore: 1, // 只显示有分数的
        subjects: [],
        sjsq: [],
      },
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '单位信息',
          dataIndex: 'danwei',
          scopedSlots: {customRender: 'danwei'},
        },
        {
          title: '赛区',
          dataIndex: 'saiqu',
          scopedSlots: {customRender: 'saiqu'},
        },
        {
          title: '分数排名',
          dataIndex: 'status',
          width: 130,
          scopedSlots: {customRender: 'status'},
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: 200,
          scopedSlots: {customRender: 'action'},
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData');
        console.log(this.queryParam);
        let that = this;

        if (this.time_range_moment[0] && this.time_range_moment[1]) {
          this.queryParam.time_range = [
            this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
            this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
          ]
        } else {
          this.queryParam.time_range = []
        }

        this.queryParam = Object.assign(this.queryParam, parameter);
        return getSubjectScoreList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
      },

      selectedRowKeys: [],
      selectedRows: [],
      cashFormData: {
        ids: [],
        to_type: '',
        price: 0,
        note: '',
        count: 0,
      },
      taskInfo: {
        urls: [],
        currentIndex: 0,
        scount: 0,
        fcount: 0,
        percent: 0,
        doing: false,
      },

      downloadAllShow: false,
      scoreUrlDownload: ''
    }
  },
  computed: {},
  created() {
  },

  mounted() {
    let that = this;
    that.getSjsqOptions();
  },
  methods: {
    moment,
    getSjsqOptions() {
      let that = this;
      sjsqOptions({}).then(res => {
        that.sjsqOptions = res.data;
      });
    },
    onSjsqChange(value) {
      let that = this;
      if (value.length == 2) {
        console.log(value);
        that.getSubjectOptions(value[1]);
      }
    },
    handleCancel() {
      this.visible = false
    },
    //展开关闭
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    getSubjectOptions(saiqu) {
      let that = this;
      subjectOptions({
        saiqu: saiqu
      }).then(res => {
        that.subjectOptions = res.data;
      });
    },
    handleEdit(record) {
      let self = this
      if (record.rank === null) {
        console.log('请先配置出场顺序')
        self.$message.error('请先配置出场顺序');
        return false;
      }
      this.visible = true

      subjectScoreDetail({id: record.id,
        type:record.type}).then(res => {
        setTimeout(() => {
          self.formData.id = record.id;
          console.log('handleEdit')
          self.formData = res.data;
        }, 200)
      })
      // console.log(this.mdl)
    },

    downloadScoreMp() {
      window.open(setting.apiBaseURL + this.scoreUrlDownload + '?_m=' + Math.random());
    },
    getTotalScore() {
      let that = this;
      let total = 0;
      let max = 0;
      let min = 100;
      let imax = this.formData.subject_name.indexOf('技巧') > 0 ? 10 : 9;
      for (var i = 1; i <= imax; i++) {
        if (this.formData['score' + i] >= max) {
          max = parseFloat(this.formData['score' + i]);
        }
        if (this.formData['score' + i] <= min) {
          min = parseFloat(this.formData['score' + i]);
        }
        total += parseFloat(this.formData['score' + i]);
      }
      console.log('total', total, max, min, total - max - min)
      total = total - max - min + parseFloat(this.formData['score_add']) - parseFloat(this.formData['score_pen']);
      return total;
    },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },

    // 增改 处理
    handleOk(e) {
      return ;
      let self = this;
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.formData)
          self.saveLoading = true;
          subjectScoreEdit(self.formData).then(res => {
            self.$message.success('修改成功')
            self.$refs.table.refresh(false)
            self.visible = false;
            self.saveLoading = false;
          }).catch(err => {
            self.$message.error(err.data.msg);
            self.saveLoading = false;
          })
        }
      })
    },


    // 批量下载
    downloadCertAll() {
      let that = this;

      if(that.queryParam.sjsq.length !=2){
        that.$message.error('请先选择赛季赛区');
        return ;
      }
      if(!that.queryParam.subjects.length){
        that.$message.error('请先选择项目');
        return
      }
      that.downloadAllShow = true

      downloadAllCert({
        saiqu: that.queryParam.sjsq[1],
        subjects: that.queryParam.subjects
      }).then(res => {
        that.taskInfo = {
          urls: res.data,
          currentIndex: 0,
          scount: 0,
          fcount: 0,
          doing: true,
        }
        that.doScoreTask(that.taskInfo);

      }).catch(err => {
        that.$message.error(err.data.msg);
      })
    },


    downloadSaiquCertAll() {
      let that = this;

      if(that.queryParam.sjsq.length !=2){
        that.$message.error('请先选择赛季赛区');
        return ;
      }
      // if(!that.queryParam.subjects.length){
      //   that.$message.error('请先选择项目');
      //   return
      // }
      that.downloadAllShow = true

      downloadAllCert({
        saiqu: that.queryParam.sjsq[1],
        subjects: []
      }).then(res => {
        that.taskInfo = {
          urls: res.data,
          currentIndex: 0,
          scount: 0,
          fcount: 0,
          doing: true,
        }
        that.doScoreTask(that.taskInfo);

      }).catch(err => {
        that.$message.error(err.data.msg);
      })
    },

    // download() {
    //   getDownloadUrl(this.queryParam).then(res => {
    //     console.log(res);
    //     window.open(res.data);
    //   })
    // },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    download(type) {
      let that = this;
      switch (type) {
        case 1:
          window.open(setting.apiBaseURL + '/adminapi/dscore/rankListDownload?' + qs.stringify(that.queryParam));
          break;
        case 2:
          window.open(setting.apiBaseURL + '/adminapi/dscore/prizeListDownload?' + qs.stringify(that.queryParam));
          break;
        case 3:
          window.open(setting.apiBaseURL + '/adminapi/dscore/resultListDownload?' + qs.stringify(that.queryParam));
          break;
        case 4:
          //秩序册更新
          that.spinning = true
          zhixuceCreate(that.queryParam).then(res => {
            that.spinning = false
            that.$message.success('更新成功')
          }).catch(err => {
            that.spinning = false
            that.$message.error(err.data.msg);
          })
          break;
        case 5:
          //秩序册下载

          zhixuceDownload(this.queryParam).then(res => {
            window.open(setting.apiBaseURL + '/' + res.data)
          }).catch(err => {
            this.$message.error(err.data.msg);
          })
          break;
        case 6:
          //秩序册PDF下载
          window.open(setting.apiBaseURL + '/adminapi/dscore/zhixucePdfDownload?' + qs.stringify(that.queryParam));
          break;
        case 7:
          //奖杯贴 冠亚军成绩下载
          window.open(setting.apiBaseURL + '/adminapi/dscore/scoreRewardDownload?' + qs.stringify(that.queryParam));
          break;
        case 8:
          console.log('请选择赛季赛区')
 
          if(this.queryParam.sjsq.length != 2){
            this.$message.error('请选择赛季赛区');
            return 
          }
          //批量下载成绩单
          window.open(setting.apiBaseURL + '/public/downloads/sai/rankList/'+that.queryParam.sjsq[1]+'/' + that.queryParam.sjsq[1]+'.zip');
          break;
      }
    },
    downloadCert(record,back) {
      window.open(setting.apiBaseURL + '/adminapi/sai/downloadCert?type='+record.type+'&subject_id=' + record.id+'&back='+back);
    },
    createRankBook(type) {
      let that = this;
      createRankBook(that.queryParam).then(res => {
        that.$message.success('生成成功')
      }).catch(err => {
        that.$message.error(err.data.msg);
      })
    },
    createPrize(type) {
      let that = this;
      createPrize(that.queryParam).then(res => {
        that.$message.success('生成成功')
      }).catch(err => {
        that.$message.error(err.data.msg);
      })
    },

    createAllRank() {
      let that = this;
      if (that.queryParam.sjsq.length != 2) {
        that.$message.error('请先选择赛季赛区');
        return;
      }
      this.createAllShow = true
      getCreateRankUrls(that.queryParam).then(res => {
        that.taskInfo = {
          urls: res.data,
          currentIndex: 0,
          scount: 0,
          fcount: 0,
          doing: true,
        }
        that.doTask(that.taskInfo);

      }).catch(err => {
        that.$message.error(err.data.msg);
      })
    },
    onDataChange(record, index, value) {
      let that = this
      console.log(record['score' + index])
      that.onScoreChange(record, index, value, record['comment' + index])
    },
    // 打分
    onScoreChange(record, score_index, value, content = '') {
      console.log('score'.score_index, record);

      let that = this
      record['score' + score_index] = value
      setScore({
        id: record.score_id,
        score_index: score_index,
        score: value,
        content: content
      }).then(res => {
        that.$message.success('打分成功') 

        that.handleEdit(record)
      }).catch(err => {
        console.log('--错误--');
        // record['score' + err.data.data.score_index] = err.data.data.score;
        that.$message.error(err.data.msg);
      })
    },

    doTask(taskInfo) {
      let that = this;
      if (taskInfo.currentIndex >= taskInfo.urls.length) {
        taskInfo.doing = false;
        return false;
      }
      doUrlTask({
        url: taskInfo.urls[taskInfo.currentIndex]
      }).then(res => {
        taskInfo.scount++;
        taskInfo.currentIndex++;
        console.log(taskInfo.currentIndex);
        if (taskInfo.currentIndex == (taskInfo.urls.length)) {
          that.scoreList2.exame.cert_zip = res.data;
        }
        taskInfo.percent = (((taskInfo.currentIndex) / taskInfo.urls.length) * 100).toFixed(1);
        that.doTask(taskInfo)
      }).catch(err => {
        taskInfo.fcount++;
        taskInfo.currentIndex++;
        taskInfo.percent = (((taskInfo.currentIndex) / taskInfo.urls.length) * 100).toFixed(1);
        that.doTask(taskInfo)
      });
    },

    doScoreTask(taskInfo) {
      let that = this;
      if (taskInfo.currentIndex >= taskInfo.urls.length) {
        taskInfo.doing = false;
        return false;
      }
      doUrlTask({
        url: taskInfo.urls[taskInfo.currentIndex]
      }).then(res => {
        taskInfo.scount++;
        taskInfo.currentIndex++;
        console.log(taskInfo.currentIndex);
        if (taskInfo.currentIndex == (taskInfo.urls.length)) {
          that.scoreUrlDownload = res.data
        }
        taskInfo.percent = (((taskInfo.currentIndex) / taskInfo.urls.length) * 100).toFixed(1);
        that.doScoreTask(taskInfo)
      }).catch(err => {
        taskInfo.fcount++;
        taskInfo.currentIndex++;
        taskInfo.percent = (((taskInfo.currentIndex) / taskInfo.urls.length) * 100).toFixed(1);
        that.doScoreTask(taskInfo)
      });
    },
    sjsqFilter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },

  },
  filters: {},
  watch: {

//      'formData':{
//        handle(val){
//          this.formData.score_total = parseFloat( this.formData.score1) + parseFloat( this.formData.score2) + parseFloat( this.formData.score3) + parseFloat( this.formData.score4) + parseFloat( this.formData.score5) + parseFloat( this.formData.score6) + parseFloat( this.formData.score7) + parseFloat( this.formData.score8) + parseFloat( this.formData.score9) + parseFloat( this.formData.score10) ;
//        },
//        deep:true
//
//      }
  }
}
</script>
